module.exports = __webpack_public_path__ + "static/media/card-testimonial2-square.4ec3af5c.png";